import { ButtonV2, Flex, TextV2 } from '@withjoy/joykit';
import React, { useCallback } from 'react';
import { JsonView } from '../JsonView';
import { QuarantineStatus, useApproveContactMessageBatchMutation, useGetQuarantinedMessagesQuery, useRejectContactMessageBatchMutation } from '@graphql/generated';
import { Username } from '../Username';
import { EventWebsiteButton } from '../EventWebsiteButton';

type ExpandedRowViewProps = {
  rowID: string;
  onGoBackClicked: () => void;
};

export const ExpandedRowView = (props: ExpandedRowViewProps) => {
  const { onGoBackClicked, rowID } = props;

  const { data: queryResults } = useGetQuarantinedMessagesQuery({
    variables: {
      filter: {
        id: rowID
      },
      sort: {}
    },
    batchMode: 'off'
  });

  const data = queryResults?.contactQuarantinedMessageBatchContainer.pagedResults.edges[0].node;

  const [approveMessageMutation] = useApproveContactMessageBatchMutation();
  const [rejectMessageMutation] = useRejectContactMessageBatchMutation();

  const onApproveClick = useCallback(() => {
    if (data) {
      approveMessageMutation({
        variables: {
          approveContactMessageBatchId: data.id
        }
      }).then(() => {
        onGoBackClicked();
      });
    }
  }, [approveMessageMutation, data, onGoBackClicked]);

  const onRejectClick = useCallback(() => {
    if (data) {
      rejectMessageMutation({
        variables: {
          rejectContactMessageBatchId: data?.id
        }
      }).then(() => {
        onGoBackClicked();
      });
    }
  }, [data, onGoBackClicked, rejectMessageMutation]);

  if (!data) {
    return null;
  }

  const reviewedAtDate = data.reviewedAt ? new Date(data.reviewedAt) : null;

  return (
    <Flex flexDirection="column">
      <Flex>
        <ButtonV2 onClick={onGoBackClicked}>Go Back</ButtonV2>
        {data.quarantineStatus === QuarantineStatus.review && (
          <>
            <ButtonV2 onClick={onApproveClick} intent="primary">
              Approve Message
            </ButtonV2>
            <ButtonV2 onClick={onRejectClick} intent="destructive">
              Reject Message
            </ButtonV2>
          </>
        )}
      </Flex>
      {reviewedAtDate && data.reviewedByUserId && (
        <>
          <TextV2>
            Reviewed at {reviewedAtDate.toLocaleDateString()} {reviewedAtDate.toLocaleString()}
          </TextV2>
          <Flex gap="0.25rem">
            <TextV2>Message was {data.quarantineStatus} by </TextV2> <Username id={data.reviewedByUserId} />
          </Flex>
        </>
      )}
      {data.eventId && <EventWebsiteButton eventId={data.eventId} />}
      {data.spamIndicatorsPayload && <JsonView data={data.spamIndicatorsPayload} />}
      <JsonView data={data.messageBatchPayload} />
    </Flex>
  );
};
